import { min } from 'lib/array/arrayUtils'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from '.'
import { GeoPlace } from 'tripPlanner/types/common'
import calculateDistance from 'lib/geo/distanceBetweenPoints'
import { getUnit, kmToFeet, kmToMiles, roundToNearest } from 'lib/geo/distanceUnits'

export function findNearestItem<T extends TripItem>(items: Array<T>, lat: number, lng: number): { item: T, place: GeoPlace, distance: number } | undefined {
  const itemsWithGeoPlaces = items
    .map(item => ({ item, place: getItemPlace(item, 'start') }))
    .filter((ip): ip is { item: T, place: GeoPlace } => ip.place?.type === 'GEO')
    .map(ip => ({ ...ip, distance: calculateDistance(lat, lng, ip.place.point.lat, ip.place.point.lng) }))

  return min(itemsWithGeoPlaces, i => i.distance)
}

export function formatDistance(distanceKM: number, currentRegionCode: string): string {
  if (getUnit(currentRegionCode) === 'mi') {
    if (distanceKM < 0.2) {
      return roundToNearest(kmToFeet(distanceKM), 10) + 'ft'
    }

    return `${kmToMiles(distanceKM).toFixed(1)}mi`
  }

  if (distanceKM > 0.95) {
    return `${distanceKM.toFixed(1)}km`
  }

  if (distanceKM < 0.05) {
    return '< 50m'
  }

  return `${Math.round((distanceKM * 1000) / 50) * 50}m`
}
